var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#81828D",
    fillRule: "evenodd",
    d: "M8.5 6.869c1.933 0 3.5-1.538 3.5-3.435C12 1.538 10.433 0 8.5 0S5 1.538 5 3.434 6.567 6.87 8.5 6.87zM16.882 14c-.674-2.838-4.17-5-8.382-5S.792 11.162.118 14H0v2h2.205A2.6 2.6 0 0 1 2 15c0-2.21 2.91-4 6.5-4s6.5 1.79 6.5 4c0 .345-.071.68-.205 1H17v-2zM8.5 4.869c-.828 0-1.5-.643-1.5-1.435S7.672 2 8.5 2s1.5.642 1.5 1.434-.672 1.435-1.5 1.435"
  })));
});
const SvgUser40X40Icon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUser40X40Icon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE3IDE2Ij4KICAgIDxwYXRoIGZpbGw9IiM4MTgyOEQiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTguNSA2Ljg2OWMxLjkzMyAwIDMuNS0xLjUzOCAzLjUtMy40MzVDMTIgMS41MzggMTAuNDMzIDAgOC41IDBTNSAxLjUzOCA1IDMuNDM0QzUgNS4zMzEgNi41NjcgNi44NyA4LjUgNi44N3pNMTYuODgyIDE0Yy0uNjc0LTIuODM4LTQuMTctNS04LjM4Mi01Uy43OTIgMTEuMTYyLjExOCAxNEgwdjJoMi4yMDVBMi41NzcgMi41NzcgMCAwIDEgMiAxNWMwLTIuMjEgMi45MS00IDYuNS00czYuNSAxLjc5IDYuNSA0YzAgLjM0NS0uMDcxLjY4LS4yMDUgMUgxN3YtMmgtLjExOHpNOC41IDQuODY5Yy0uODI4IDAtMS41LS42NDMtMS41LTEuNDM1UzcuNjcyIDIgOC41IDJzMS41LjY0MiAxLjUgMS40MzRjMCAuNzkyLS42NzIgMS40MzUtMS41IDEuNDM1eiIvPgo8L3N2Zz4K";